import reactdomclient from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import {
    NavBar,
    Home,
    Footer,
    Routines,
    Account,
    Activities,
    MyRoutines,
    MakeRoutine,
    MakeActivity,
    EditRoutine,
    AttachActivity,
    EditRoutineActivity
} from "./components"

const App = () => {
    const [username, setUsername] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [token, setToken] = useState("");
    const [routines, setRoutines] = useState([]);
    const [routineId, setRoutineId] = useState(undefined);
    const [withActivities, setWithActivities] = useState(true);
    const [activities, setActivities] = useState([]);
    const [makeRoutine, setMakeRoutine] = useState(false);
    const [editRoutine, setEditRoutine] = useState(false);
    const [makeActivity, setMakeActivity] = useState(false);
    const [attachActivity, setAttachActivity] = useState(false);
    const [editRoutineActivity, setEditRoutineActivity] = useState(false);
    const [editName, setEditName] = useState("");
    const [editGoal, setEditGoal] = useState("");
    const [editCount, setEditCount] = useState(0);
    const [editDuration, setEditDuration] = useState(0);
    const [routineActivityId, setRoutineActivityId] = useState("");
    const [user, setUser] = useState("");
    const [userRoutines, setUserRoutines] = useState([]);
    const [fromActivities, setFromActivities] = useState(false);
    const [activityId, setActivityId] = useState('')


    const logOut = () => {
        localStorage.removeItem("token");
        setLoggedIn(false);
        setToken("");
    };

    useEffect(() => {
        let savedToken = localStorage.getItem("token");
        if(savedToken) {
            setLoggedIn(true);
            setToken(savedToken)
        }
    }, []);

    return <>

        <NavBar loggedIn={loggedIn} logOut={logOut} setMakeActivity={setMakeActivity} setMakeRoutine={setMakeRoutine} setEditRoutine={setEditRoutine} setAttachActivity={setAttachActivity} setEditRoutineActivity={setEditRoutineActivity} setFromActivities={setFromActivities} setActivityId={setActivityId}/>
        <Routes>
            <Route path="/" element={<Home loggedIn={loggedIn} />}></Route>
            <Route path="account" element={<Account setToken={setToken} setLoggedIn={setLoggedIn} username={username} setUsername={setUsername} />}></Route>
            <Route path="routines" element={<Routines routines={routines} setRoutines={setRoutines} setFromActivities={setFromActivities} setActivityId={setActivityId} 
            activityId={activityId} fromActivities={fromActivities}/>}></Route>
            <Route path="my_routines" element={<MyRoutines token={token} username={username} setMakeRoutine={setMakeRoutine} setEditRoutine={setEditRoutine} 
            setRoutineId={setRoutineId} setEditGoal={setEditGoal} setEditName={setEditName} setUser={setUser} setUserRoutines={setUserRoutines} 
            userRoutines={userRoutines} user={user} setAttachActivity={setAttachActivity} setRoutineActivityId={setRoutineActivityId} 
            setEditRoutineActivity={setEditRoutineActivity} setEditCount={setEditCount} setEditDuration={setEditDuration}/>}></Route>
            <Route path="activities" element={<Activities token={token} activities={activities} setActivities={setActivities} loggedIn={loggedIn}
            setMakeActivity={setMakeActivity} setActivityId={setActivityId} setFromActivities={setFromActivities}/>}></Route>
        </Routes>

        { makeRoutine ? <MakeRoutine token={token} setMakeRoutine={setMakeRoutine} activities={activities} setActivities={setActivities}/> : null }
        { makeActivity ? <MakeActivity token={token} setMakeActivity={setMakeActivity}/> : null }
        <Footer/>
        { editRoutine ? <EditRoutine token={token} routineId={routineId} setEditRoutine={setEditRoutine} editName={editName} setEditName={setEditName} editGoal={editGoal} setEditGoal={setEditGoal} setUser={setUser} setUserRoutines={setUserRoutines}/> : null }
        { attachActivity ? <AttachActivity token={token} routineId={routineId} activities={activities} setActivities={setActivities} setAttachActivity={setAttachActivity}/> : null }
        { editRoutineActivity ? <EditRoutineActivity editCount={editCount} editDuration={editDuration} routineActivityId={routineActivityId} setEditRoutineActivity={setEditRoutineActivity} setEditCount={setEditCount} setEditDuration={setEditDuration} token={token}/> : null }
    </>
};

const root = reactdomclient.createRoot(document.getElementById("App"));
root.render(<BrowserRouter><App/></BrowserRouter>);